module.exports = __webpack_public_path__ + "static/media/verifyFailed-mobile.f5940215.png";